import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  getRegionCreateActions,
  setRegionetrieveAction,
  setRegionEditActions,
  setGeoLoactionStateAction,
  setTablePositionPersist
} from "../../../Redux/Slice";
import Select from "react-select";
import "../../../StyleSheet/MainComponent/RegionCreate/RegionCreate.scss";
import useDebouncedEffect from 'use-debounced-effect';

const RegionCreateFrom = (props) => {
  const { show, setShow, currentPage, EditId, stateID , search } = props;
  let [nameList, setOptions] = useState([]);
  const [multiselect, setMuliselect] = useState([]);
  const [stateerror, setStateError] = useState("");
  const [States, setState] = useState([]);
  const state = useSelector((state) => state);
   const TablePositionPersist = useSelector(state=>state.PreviousPagePosition.TablePositionPersist)
  
  const initialState = {
    region: "",
    Descriptions: "",
    state_id: "",
  };
  const [data, setDatas] = useState(initialState);
  const [RegionError, setRegionError] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const HandleSubmits = (e) => {
    e.preventDefault();
  };

  const initialStateSearch = {
    stateSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
  };

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


useDebouncedEffect(
  () => {
      if (setSearchDebounance) {
          setSearched({
              ...SearchedVal,
              stateSearch: SearchDebounance.stateSearch,
          });
      }
  },
  500,
  [SearchDebounance]
);


  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,
    });
};

  const handleInputChangeCreate = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
  });
  };
  //----State------------------------------
  const State = useSelector((state) => state);
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
    setState(state.GeoState.State);
  }, [SearchedVal.stateSearch]);
  ///--------------------State----------------------
  useEffect(() => {
    const Datas = [];

    setState(state.GeoState.State.state_name);
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);

  useEffect(() => {
    // console.log(EditId, "iysoidfh");
    if (EditId != undefined && EditId != "") {
      const payload = {
        EditId: EditId,
      };
      dispatch(setRegionetrieveAction(payload));
      console.log(State.RegionRetrieve.RegionRetrieve, "states");
    }
  }, []);

  useEffect(() => {
    if (
      EditId != undefined &&
      EditId != "" &&
      State.RegionRetrieve.RegionRetrieve.id
    ) {
      setDatas({
        ...data,
        region: State.RegionRetrieve.RegionRetrieve.region_name,

        Descriptions: State.RegionRetrieve.RegionRetrieve.description,
        state_id: state.RegionRetrieve.RegionRetrieve.state_id.id,
      });
    }
  }, [State.RegionRetrieve.RegionRetrieve]);

  useEffect(() => {
    if (
      EditId != undefined &&
      state.RegionRetrieve.RegionRetrieve.id != undefined &&
      state.RegionRetrieve.RegionRetrieve.id != undefined
    ) {
      let objectState = [];
      objectState.push({
        value: state.RegionRetrieve.RegionRetrieve.state_id.id,
        label: state.RegionRetrieve.RegionRetrieve.state_id.state_name,
      });
      SetStates(objectState);
      console.log(
        SelectedStates,
        "asfsdf",
        state.RegionRetrieve.RegionRetrieve
      );
    }
  }, [state.RegionRetrieve.RegionRetrieve]);

  const HandleChanges = (e) => {

     const { name, value } = e.target;
  const cleaned = value.replace(/[^a-zA-Z ]/g, "");

  let limited = cleaned; 

  if (name === "region") {
    limited = cleaned.slice(0, 40);

      setDatas((prev) => ({
    ...prev,
    [name]: limited,
  }));

  } else if (name == "Descriptions") {
      setDatas((prev) => {
        return {
          ...prev,
          [name]: e.target.value.slice(0, 300),
        };
      });
    }
  };

  //----State----
  const handleSelectChange = (selectedVal) => {
    setMuliselect(selectedVal);
    setDatas({
      ...data,
      state_id: selectedVal.value,
    });
  };
  //----State----Edits
  const [stateMul, setStateMul] = useState([]);
  const [SelectedStates, SetStates] = useState([]);

  const handleState = (sel) => {
    setStateMul(sel);
    SetStates(sel);
    setDatas({
      ...data,
      state_id: sel.value,
    });
    // console.log(SelectedStates, "statesdassssss");
  };

  const handleClose = () => {
    setShow(false);
  };

  const dispatch = useDispatch();

  const HandleSubmit = () => {
    // console.log(datas);

    if (
      EditId == undefined ||
      EditId == "" ||
      !State.RegionRetrieve.RegionRetrieve.id
    ) {
      var a = 0;
      if (data.region == "") {
        a = 1;
        setRegionError("*Region is Required");
      }
      if (data.Descriptions == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }
      if (data.state_id == "") {
        a = 1;
        setStateError("*State  is required");
      }
      if (a == 0) {
        // console.log(datas ,"inner");
        const payload = {
          data: data,
          currentPage: currentPage,
          state: stateID,
          search:search
        };
const newEntry = { updated: true };
        const result = {
          ...TablePositionPersist.Overall_RegionDatas,
         page: 1, // Set page to 1
          ...newEntry
        };
                
        dispatch(
          setTablePositionPersist({
            data: result,
            pageName: "Overall_RegionDatas",
          }))
        dispatch(getRegionCreateActions(payload, props.setShow()));
      }
    }
  };

  const HandleEdits = () => {
    if (EditId != undefined && EditId != "") {
      var a = 0;
      if (data.region == "") {
        a = 1;
        setRegionError("*Region is Required");
      }
      if (data.Descriptions == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }
      if (data.state_id == "") {
        a = 1;
        setStateError("*State  is required");
      }
      if (data.region !== "" && data.Descriptions !== "") {
        const payload = {
          data: data,
          currentPage: currentPage,
          EditId: EditId,
          state: stateID,
          search:search

        };
        const newEntry = { updated: true };
                const result = {
                  ...TablePositionPersist.Overall_RegionDatas,
                 page: 1, // Set page to 1
                  ...newEntry
                };
                        
                dispatch(
                  setTablePositionPersist({
                    data: result,
                    pageName: "Overall_RegionDatas",
                  }))

        dispatch(setRegionEditActions(payload, props.setShow()));
      }
    }
  };
  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups">
            <div className="asds">
              <div class="ModalHeader">
                {EditId == undefined || EditId == "" ? (
                  <span className="UserCreate">Region </span>
                ) : (
                  <span> Region </span>
                )}

                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>

              <form class="row g-3 Filters form-fields-wrapper" onClick={HandleSubmits}>
                <div class="col-12 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Region  <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={data.region}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setRegionError("");
                    }}
                    required
                    name="region"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "10px" }}>
                    {RegionError}
                  </p>
                </div>

                <div class="col-12 field-div">
                  <label
                    for="validationCustom02"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Description <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    type="text"
                    class="form-control"
                    autoComplete="off"
                    value={data.Descriptions}
                    onChange={(e) => {
                      HandleChanges(e);
                      setDescriptionError("");
                    }}
                    name="Descriptions"
                    required
                    style={{
                      padding: "10px",
                    }}
                  ></textarea>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {DescriptionError}
                  </p>
                </div>
                {EditId == undefined || EditId == "" ? (
                  <div className="col Filters " id="RegionCreatePOPUP" style={{width:"200px", marginTop:"82px"}}>
                    <label for="validationCustom01" class="form-label">
                      State Name<span style={{ color: "red" }}>*</span>
                    </label>

                    <Select
                      className="Selects"
                      styles={{
                        position: "relative",
                        top: "60px",
                        padding: "70vh",
                      }}
                      // options={options}
                      // onChange={handleChange}
                      onSelect={(e) => setMuliselect(e)}
                      onChange={(e) => {
                        handleSelectChange(e);
                        setStateError("");
                      }}
                      onInputChange={handleInputChangeCreate}
                      options={nameList}
                      labelledBy="Select"
                    />
                    <p style={{ color: "red", marginTop: "10px" }}>
                      {stateerror}
                    </p>
                  </div>
                ) : (
                  <div className="col Filters"  style={{marginTop:"80px", width:"200px"}}id="RegionCreatePOPUP">
                    <label for="validationCustom01" class="form-label">
                      State<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      className="Selects"
                      styles={{
                        position: "relative",
                        top: "60px",
                        padding: "70vh",
                      }}
                      // options={options}
                      // onChange={handleChange}
                      onSelect={(e) => setStateMul(e)}
                      onChange={(e) => {
                        handleState(e);
                        setStateError("");
                      }}
                      onInputChange={handleInputChange}
                      options={nameList}
                      value={SelectedStates}
                      labelledBy="Select"
                    />
                    <p className="Error" style={{ marginTop: "10px" }}>
                      {stateerror}
                    </p>
                  </div>
                )}
              </form>

              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <button
                  class="btn  SaveBtn"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);

                    HandleEdits(e);
                  }}
                >
                  Submit
                </button>

                <button class="btn CancelBtn" onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegionCreateFrom;
